import content_dir from 'src/_store/content_dir'

const initialState = {
  current_dir: '/CalorieMate/LIQUID',
  cmd_head: {
    txt_01: 'caloriemateliquid',
    txt_02: ' $',
  },
  cmd_history: [],
  // cmd_history : [
  //   {
  //     dir: '', // 実行時のディレクトリ
  //     cmd: '', // 実行コマンド（inputそのまま）
  //     date: '', //dateコマンド叩かれたタイミングで保持（dateコマンド時に表示するやつ）
  //     is_created: false, // 1回のみアニメーション：mountedの初期アニメで対応できなかったらこれ使う。
  //     is_cleared: false, // clearコマンド使われた段階で全部trueに。コマンド履歴は残りつつレスポンスさせなくしたい時にこれ使う。
  //     uid: '',
  //     index: 0 // 連番(historyで使う),
  //     is_tab_clicked: false // タブクリック判定
  //     is_secret_valid: false
  //   },
  // ]
  content_dir: content_dir,
  cmd_tab: {
    cmd: '',
    is_change_toggle: false, // 常にトグル。useEffectで変化をリッスン
  },
  mobile_status: {
    is_mobile: false,
    is_portrait: false,
  },
  is_cmd_exit: false,
  load_status: {
    status: '',
  },
  secret_id: '',
  secret_cmd_value: '',
  secret_played_toggle: false, // 演出が終わったら常時toggleで切り替え。(コンポーネントで検知したい)
  OH_YOU_FOUND_ME:
    'Thank you for finding this message! You are modern hacker! :)',
  is_quine_playing: false,
}

export default initialState
